/* eslint-disable react/react-in-jsx-scope */
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { useMediaQuery, useTheme } from "@mui/material";
import ControlZoomBtns from "./custom-zoom-btns";

const MAPBOX_API_KEY = process.env.REACT_APP_MAPBOX_API_KEY;

const DefaultIcon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
  shadowSize: [41, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

type Props = {
  latitude: number | null | undefined;
  longitude: number | null | undefined;
  zoom?: number;
  height?: string;
  width?: string;
  borderRadius?: string;
};

export default function MapComponent({
  latitude,
  longitude,
  zoom = 12,
  height,
  width = "100%",
  borderRadius = "8px",
}: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const computedHeight = height || (isMobile ? "132px" : "230px");

  // prevent Leaflet crash if lat & long not number
  if (typeof latitude !== "number" || typeof longitude !== "number") {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "12rem",
        }}
      >
        Location not available
      </div>
    );
  }

  return (
    <MapContainer
      center={[latitude, longitude]}
      zoom={zoom}
      zoomControl={false}
      style={{
        height: computedHeight,
        width,
        borderRadius,
      }}
    >
      {/* OpenStreetMap tiles */}
      <TileLayer
        attribution='&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> contributors, &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url={`https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=${MAPBOX_API_KEY}`}
        id="mapbox/streets-v11"
      />

      {/* Marker on your coords */}
      <Marker position={[latitude, longitude]}>
        <Popup>
          Lat: {latitude}, Lng: {longitude}
        </Popup>
      </Marker>

      {/* Zoom buttons for Map */}
      <ControlZoomBtns />
      
    </MapContainer>
  );
}
